import * as React from "react";
import { forwardRef } from "react";
const SvgBottomOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 7 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M6.13282 0L3.5 2.41146L0.86718 0L0 0.79427L3.5 4L7 0.79427L6.13282 0Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgBottomOutlined);
export default ForwardRef;
